import { getNotificationRepository } from "@/infrastructure/di";
import { useCreateMutation } from "../createMutation";
import { EVERY_NOTIFICATION, notificationCache, USER_INBOX, type NotificationPatch } from "./cache";

const inbox = notificationCache.at(USER_INBOX);
const READ: NotificationPatch = { is_read: true };
const UNREAD: NotificationPatch = { is_read: false };

export const useMarkNotificationRead = () =>
  useCreateMutation({
    mutationFn: (uuid: string) => getNotificationRepository().markAsRead(uuid),
    cache: (c) => c.patch(inbox, { id: (uuid) => uuid, optimistic: () => READ }),
    errorLogMessage: "Failed to mark notification as read:",
  });

export const useMarkNotificationUnread = () =>
  useCreateMutation({
    mutationFn: (uuid: string) => getNotificationRepository().markAsUnread(uuid),
    cache: (c) => c.patch(inbox, { id: (uuid) => uuid, optimistic: () => UNREAD }),
    errorLogMessage: "Failed to mark notification as unread:",
  });

export const useMarkAllNotificationsRead = () =>
  useCreateMutation({
    mutationFn: () => getNotificationRepository().markAllAsRead(),
    cache: (c) => c.patch(inbox, { id: () => EVERY_NOTIFICATION, optimistic: () => READ }),
    errorLogMessage: "Failed to mark all notifications as read:",
  });

export const useDeleteNotification = () =>
  useCreateMutation({
    mutationFn: (uuid: string) => getNotificationRepository().deleteNotification(uuid),
    cache: (c) => c.remove(inbox, { id: (uuid) => uuid, optimistic: true }),
    errorLogMessage: "Failed to delete notification:",
  });

export const useDeleteAllNotifications = () =>
  useCreateMutation({
    mutationFn: () => getNotificationRepository().deleteAllNotifications(),
    cache: (c) => c.remove(inbox, { id: () => EVERY_NOTIFICATION, optimistic: true }),
    errorLogMessage: "Failed to delete all notifications:",
  });
